export default __webpack_public_path__ + "static/media/icaew_s1.ad6563ea.png";